export const INFCON_2024_COLOR_PALETTE = {
  blue: '#00A2DF',
  backgroundBlue: '#0086CD',
  darkBlue: '#004290',
  lightBlue: '#F5FBFE',
  backgroundGray: '#F8F9FA',
  cyan: '#05B9DF'
};
